"use client";

import React from "react";
import CtaBand from "@/components/common/CtaBand";
import { useLanguage } from "@/hooks/useLanguage";
import { pick, type Lang } from "@/lib/i18n";
import { COMMON } from "@/lib/commonCopy";
import { Mail } from "lucide-react";
interface Copy {
  eyebrow: string;
  heading: string;
  lead: string;
  secondaryLabel: string;
}
const copyData: Record<Lang, Copy> = {
  en: {
    eyebrow: "Direct Engineering Support",
    heading: "Ready to review your filter component specifications?",
    lead: "Send us your target micron rating, stainless steel alloy, and component drawings. Our technical team reviews your drawing files and returns manufacturing feasibility with dimensional tolerances.",
    secondaryLabel: "Contact engineering team"
  },
  zh: {
    eyebrow: "工程技术直接支持",
    heading: "准备好评估您的过滤组件规格了吗？",
    lead: "请发送您的目标过滤精度、不锈钢合金牌号及组件图纸。我们的技术团队将审核图纸文件并提供包含尺寸公差的制造可行性方案与报价。",
    secondaryLabel: "联系工程团队"
  },
  es: {
    eyebrow: "Soporte directo de ingeniería",
    heading: "¿Listo para revisar las especificaciones de sus componentes filtrantes?",
    lead: "Envíenos su micraje objetivo, aleación de acero inoxidable y planos de componentes. Nuestro equipo técnico evaluará sus especificaciones y proporcionará tolerancias dimensionales.",
    secondaryLabel: "Contactar al equipo técnico"
  },
  de: {
    eyebrow: "Direkte technische Beratung",
    heading: "Bereit zur Prüfung Ihrer Filterkomponenten-Spezifikationen?",
    lead: "Senden Sie uns die gewünschte Filterfeinheit, Edelstahlgüte und Fertigungszeichnungen. Unser Fachteam analysiert Ihre Daten und erstellt eine Machbarkeitsprüfung inklusive Maßtoleranzen.",
    secondaryLabel: "Technikteam kontaktieren"
  },
  fr: {
    eyebrow: "Support technique direct",
    heading: "Prêt à examiner les spécifications de vos composants de filtration ?",
    lead: "Transmettez-nous votre seuil de filtration, la nuance d'acier inoxydable et les plans de pièces. Notre équipe technique évaluera vos tolérances dimensionnelles et la faisabilité de fabrication.",
    secondaryLabel: "Contacter l'équipe technique"
  },
  pt: {
    eyebrow: "Suporte direto de engenharia",
    heading: "Pronto para avaliar as especificações dos seus componentes de filtração?",
    lead: "Envie sua retenção em mícrons, grau de aço inoxidável e desenhos técnicos. Nossa equipe de engenharia analisa suas tolerâncias dimensionais e apresenta um estudo de viabilidade.",
    secondaryLabel: "Falar com a equipe técnica"
  }
};
export default function QuoteBanner() {
  const {
    lang
  } = useLanguage();
  const content = pick(lang, copyData);
  return <CtaBand id="quotecta" eyebrow={content.eyebrow} heading={content.heading} lead={content.lead} primary={{
    label: pick(lang, COMMON.requestQuote),
    to: "/RequestAQuotePage"
  }} secondary={{
    label: content.secondaryLabel,
    to: "/ContactPage",
    icon: Mail
  }} />;
}